import { CLASS_NAME_PREFIX } from "../__config__/constants";

export const LinkClassName = `${CLASS_NAME_PREFIX}-link`;
export const LinkStartIconClassName = `${LinkClassName}__start-icon`;
export const LinkEndIconClassName = `${LinkClassName}__end-icon`;
export const LinkTextClassName = `${LinkClassName}__text`;
